import { PhoneNumberSources } from 'calling-internal-common/constants/PhoneNumberSources';
import { getSource } from './FromNumberGetters';
export const getIsHubSpotProvidedNumber = fromNumber => {
  return getSource(fromNumber) === PhoneNumberSources.HUBSPOT_NUMBER;
};